export const BASE_URL = 'https://place.industry.art/api/v1/';
export const BASE_URL_V2 = 'https://place.industry.art/api/v2/';
export const MEDIA_URL = 'https://place.industry.art';
export const CLUSTER_API = 'https://place.industry.art/cluster/api/v1/';
// export const CLUSTER_API = 'http://127.0.0.1:5001/cluster/api/v1/';
